import { gql } from '@apollo/client';

export const CREATE_EXTERNAL_CONTENT_MUTATION = gql`
  mutation CreateExternalContent($data: createExternalContentInput!) {
    createExternalContent(input: $data) {
      externalContent {
        id
        title
        body
        hashtags
        publicationState
        platform
        post {
          id
        }
      }
    }
  }
`;
